export default "__VITE_ASSET__ea100328__"